module.exports = __webpack_public_path__ + "img/hero-closed.938e08f2.png";